import $ from 'jquery';

class VideoWrapper {
    // This wraps viemo and youtube iframes in a parent with class iframe-wrapper, which is then used to set aspect ratio. Use case is when videos have been added in wysiwyg field. This JS can be slow – so where possible, use retconWrap instead. That doesn't conflict with this JS approach, since the JS will just see the iframe-wrapper class already exists.
    constructor() {
        this.initialize();
    }

    initialize() {
        // Get all vimeo and youtube iframes
        this.$allVideos = $(
            "iframe[src^='//player.vimeo.com'], iframe[src^='//www.youtube.com'], iframe[src^='https://www.youtube.com'], iframe[src^='//www.youtube-nocookie.com'], iframe[src^='https://www.youtube-nocookie.com']"
        );
        this.resizeVideo();
    }

    resizeVideo() {
        this.$allVideos.each(function() {
            $(this)
                .parent()
                .addClass('iframe-wrapper');
        });
    }

    static init() {
        if ($('figure iframe').length > 0) {
            new VideoWrapper();
        }
    }
}

export default VideoWrapper;
